import { HUtils } from "../apps/Helpers";

const Utils = {
  TickTock:{
    data:{},
  },
  tick(name){
    let _d = Date.now();
    Utils.TickTock.data[name] = {
      tick: _d
    }
  },
  tock(name){
    let _d = Date.now();
    if(Utils.TickTock.data[name]){
      Utils.TickTock.data[name].tock = _d;
      Utils.TickTock.data[name].time = Utils.TickTock.data[name].tock - Utils.TickTock.data[name].tick;
      console.warn(`TICK TOCK`,name,Utils.TickTock.data[name].time,Utils.TickTock.data[name]);
    }
  },
  getDeltaTime(lastTime){
    let _now = new Date();
    let _delta = 0;
    if(lastTime){
      _delta = _now - lastTime;
    }
    return _delta;
  },
  randomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  },
  getIconClassFile(type){
    let _classNameFileIcon = "fa fa-file-o";
    if(type!=null){
      if(type.indexOf('image')>-1){
        _classNameFileIcon = "fa fa-file-photo-o";
      }
      else if(type.indexOf('pdf')>-1){
        _classNameFileIcon = "fa fa-file-pdf-o";
      }
      else if(type.indexOf('.document')>-1){
        _classNameFileIcon = "fa fa-file-word-o";
      }
      else if(type.indexOf('.sheet')>-1){
        _classNameFileIcon = "fa fa-file-excel-o";
      }
    }
    return _classNameFileIcon;
  },
  getProjectIdInMatch(props={}){
    const {match} = props;
    // console.warn("getProjectIdInMatch:",props,match)
    if(props.projectId){
      return props.projectId;
    }
    if(match && match.params!=null){      
      if(match.params.projectId!=null){
        return match.params.projectId;
      }
      if(match.params.id!=null){
        return match.params.id;
      }
    }
  },
  isRunOnMobile(){
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  },
  getYoutubeID(url){
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
  },
  parseOptionsLogoConfig(options){
    if(options && options.Configs && options.Configs.LogoConfig && options.Configs.LogoConfig.Url){
      let _e = document.getElementById("brandlogo");
      if(_e){
        _e.href = options.Configs.LogoConfig.Url;
      }
    }
  },
  updateDataWithNewData(oldData,newData,{fieldId="Id",prefixNotUpdate="_",customUpdate}={}){
    if(oldData && newData){
      let _isCondition = true;
      if(fieldId){
        _isCondition = oldData[fieldId]===newData[fieldId];
      }
      if(_isCondition){
        Object.keys(newData).map((v,i)=>{
          if(customUpdate){
            customUpdate(oldData,newData,v);
          }
          else{
            oldData[v] = newData[v];
          }          
        })
      }      
    }
  },
  runFnList(fnList,fnName,context=this,args,{defaultValue}={}){//context se quyet dinh this nam o dau, neu array function thi ko lien quan toi context
    if(fnList && fnName && fnList[fnName]){
      return fnList[fnName].apply(context,args);
    }
    return defaultValue;
  },
  runFnConfig(configBuild,fnName,arrArguments,dfFn){
    if(configBuild && configBuild.fnList && configBuild.fnList[fnName]){
      configBuild.fnList[fnName].apply(configBuild,arrArguments);
    }else if(dfFn){
      dfFn.apply(configBuild,arrArguments);
    }
  },
  getInObj(obj,path){
    if(obj && path){
      let _value;
      let _arrPath = path.split('.');
      for(let k of _arrPath){
        
      }
    }
  },
  arrayObj2ObjWithKey: function(arr, keyField) {
    var rv = {};
    if (arr != null) {
      for (var i = 0; i < arr.length; i++) {
        var _vf = arr[i][keyField] || i;
        rv[_vf] = arr[i];
      }
    } else {
      console.log("arrayObj2ObjWithKey: arr null");
    }
    return rv;
  },
  xoaDauInText: function(s){
    let str = s + "";//phai chac chan la chuoi
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/Đ/g, "D");
    str = str.replace(/\s/g,'');
    str = str.replace(/[^A-Za-z0-9!?]/g,'');
    str = str.toLowerCase();
    return str;
  },
  extractPhoneFromText: function(text){
    let _result = []
    if(text){
      const _regrexNumber = /^[0-9]*$/;
      const _regrexString = /[\d\.]+|\D+/g;
      
      let _splitString = text.match(_regrexString);
      for(let i=0; i<_splitString.length>0; i++){
        const _item = _splitString[i];
        if(_item.length > 7 && _item.length <=12 && _regrexNumber.test(_item) == true){
          _result.push(_item)
        }
      }
    }
    return _result
  },
  getQueryFromObj: function(query, obj){
    let _result = {}
    if(query && obj){
      let _keys = Object.keys(query);
      if(_keys.length > 0){
        for(let i=0; i<_keys.length; i++){
          const _k = _keys[i]
          if(obj.hasOwnProperty(query[_k])){
            _result[_k] = obj[query[_k]];
          }
        }
      }
    }
    return _result
  },
  Obj:{
    groupFromArray(arr,fieldKey,typeItem='array'){
      //[{k1:"a1",k2:"a2"},{k1:"a12",k2:"a22"}]=>{k1:[{k1:"a1",k2:"a2"}],k2:[{k1:"a12",k2:"a22"}]}
      let _group = {};
      if(arr && arr.length>0){
        for(let i=0;i<arr.length;i++){
          let _item = arr[i];
          let _key = _item[fieldKey] || 'nokey';
          if(_group[_key]==null){
            if(typeItem=='object'){
              _group[_key] = {};
            }     
            else{
              _group[_key] = [];
            }    
          }
          if(_group[_key]!=null){
            if(typeItem=='object'){
              _group[_key]=_item;
            } 
            else{
              _group[_key].push(_item);
            }            
          }
        }
      }
      return _group;
    },
    groupFromArray2Level(arr,fieldKey1,fieldKey2){
      //[{k1:"a1",k2:"a2"},{k1:"a12",k2:"a22"}]=>{k1:[{k1:"a1",k2:"a2"}],k2:[{k1:"a12",k2:"a22"}]}
      let _group = Utils.Obj.groupFromArray(arr,fieldKey1);
      if(_group && fieldKey2){
        let _allKeys = Object.keys(_group);
        if(_allKeys && _allKeys.length>0){
          for(let k of _allKeys){
            let _arrOfKey1 = _group[k];
            let _group2 = HUtils.Obj.groupFromArray(_arrOfKey1,fieldKey2,'object');
            _group[k] = _group2;
          }
        }        
      }
      return _group;
    },
    fastDeepEqual(a,b){
      if (a === b) return true;
      if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
          length = a.length;
          if (length != b.length) return false;
          for (i = length; i-- !== 0;)
            if (!Utils.Obj.fastDeepEqual(a[i], b[i])) return false;
          return true;
        }

        if ((a instanceof Map) && (b instanceof Map)) {
          if (a.size !== b.size) return false;
          for (i of a.entries())
            if (!b.has(i[0])) return false;
          for (i of a.entries())
            if (!Utils.Obj.fastDeepEqual(i[1], b.get(i[0]))) return false;
          return true;
        }
    
        if ((a instanceof Set) && (b instanceof Set)) {
          if (a.size !== b.size) return false;
          for (i of a.entries())
            if (!b.has(i[0])) return false;
          return true;
        }
    
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
          length = a.length;
          if (length != b.length) return false;
          for (i = length; i-- !== 0;)
            if (a[i] !== b[i]) return false;
          return true;
        }
    
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
    
        for (i = length; i-- !== 0;)
          if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    
        for (i = length; i-- !== 0;) {
          var key = keys[i];
          if (key === '_owner' && a.$$typeof) {
            // React-specific: avoid traversing React elements' _owner.
            //  _owner contains circular references
            // and is not needed when comparing the actual elements (and not their owners)
            continue;
          }
          if (!Utils.Obj.fastDeepEqual(a[key], b[key])) return false;
        }
        return true;
      }
      // true if both NaN, false otherwise
      return a!==a && b!==b;
    },
    get: function (obj, path, def) {
      /**
       * If the path is a string, convert it to an array
       * @param  {String|Array} path The path
       * @return {Array}             The path array
       */
      if(obj!=null && typeof obj=="object"){
        var stringToPath = function (path) {
          // If the path isn't a string, return it
          if (typeof path !== 'string') return path;
          // Create new array
          var output = [];
          // Split to an array with dot notation
          path.split('.').forEach(function (item, index) {
            // Split to an array with bracket notation
            item.split(/\[([^}]+)\]/g).forEach(function (key) {
              // Push to the new array
              if (key.length > 0) {
                output.push(key);
              }
            });
          });
          return output;
        };
        // Get the path as an array
        path = stringToPath(path);
        // Cache the current object
        var current = obj;
        // For each item in the path, dig into the object
        for (var i = 0; i < path.length; i++) {
          // If the item isn't found, return the default (or null)
          if (current[path[i]]==null) return def;
          // Otherwise, update the current  value
          current = current[path[i]];
        }
        return current;
      }
      else{
        return def;
      }      
    },
    notNull: function (obj, path, def) {
      if(obj!=null && typeof obj=="object"){
        var stringToPath = function (path) {
          if (typeof path !== 'string') return path;
          var output = [];
          path.split('.').forEach(function (item, index) {
            item.split(/\[([^}]+)\]/g).forEach(function (key) {
              if (key.length > 0) {
                output.push(key);
              }
            });
          });
          return output;
        };
        path = stringToPath(path);
        var current = obj;
        for (var i = 0; i < path.length; i++) {
          if (current[path[i]]==null) return false;
          current = current[path[i]];
        }
        return true;
      }
      else if(obj!=null){
        return true;
      }else{
        return false;
      }  
    }
  },
  SquareBracket:{
    regex: /\[(.[^\]]*)\]/gm,
    extract(s) {
      var _result = [];
      if (s != null) {
        var _m;
        while ((_m = Utils.SquareBracket.regex.exec(s)) !== null) {
          if (_m.length > 1) {
            _result.push(_m[1]);
          }
        }
      }
      return _result;
    },
    replace(s, obj) {//replace nhieu gia tri, tra ve 1 string
      var extract = Utils.SquareBracket.extract(s);
      var newS = s;
      if (extract != null) {
        for (var _item of extract) {
          if (obj[_item] != null) {
            var rg = new RegExp(`\\[${_item}\\]`, "g");
            newS = newS.replace(rg, obj[_item]);
          }
        }
      }
      return newS;
    },
    getValueOfObj(s, obj) {//tra ve 1 gia tri trong obj
      var extract = Utils.SquareBracket.extract(s);
      if (extract != null) {
        for (var _item of extract) {
          return obj[_item];
        }
      }
    }
  },
  Style:{
    getByWidth(obj,df){//get by config width
      let _objRes = obj || df;
      if(typeof obj=='object'){      
        if(obj.default){
          _objRes = obj.default;
        }
        else{ //bat buoc co default moi xet width
          return _objRes;
        }
        const windowWidth = window && window.innerWidth || Infinity;
        let matchedBreakpoint = Infinity;
        for(let k of Object.keys(obj)){
          const optBreakpoint = parseInt(k);
          const isCurrentBreakpoint = optBreakpoint > 0 && windowWidth <= optBreakpoint;
          if(isCurrentBreakpoint && optBreakpoint < matchedBreakpoint) {
            matchedBreakpoint = optBreakpoint;
            _objRes = obj[k];
          }
        }
      }
      return _objRes;
    },
    getStyleByWidth(obj){
      if(obj && obj.default){
        return Utils.Style.getByWidth(obj,{});
      }
      return obj;
    },
    getNumCol(col,df=1){//number or object
      let _numCol = col || df;
      if(typeof _numCol == "number"){
        return _numCol;
      }
      return Utils.Style.getByWidth(_numCol,df);
    },
    getWidthPercentCol(numCol=1,{colGapPercent}={}){
      let _width = 100;
      let _fullWidth = 100;
      if(colGapPercent && numCol>1){
        _fullWidth -= (numCol - 1);
      }
      if(numCol>0){
        _width = Math.floor(_fullWidth/numCol*100)/100;
      }    
      return `${_width}%`;
    }
  }
}

window.SquareBracket = Utils.SquareBracket;
window.HUtils = Utils;
export default Utils;